import { util } from './utils'
import axios from 'axios'
import { DS_API_BASE_URL } from '@/api/base'

const ds = {}

ds.getTicketFunc = (paramUrl, app, paramInfo) => {
  let urlData = util.getUrlkey(paramUrl)
  let jsonData = {
    'url': paramUrl,
    'mark': urlData['mark']
  }

  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: `${DS_API_BASE_URL}/joywok/get_ticket`,
      data: jsonData
    }).then(result => {
      let resultData = result.data
      if (resultData.code == 0) {
        let dataInfo = resultData.data
        jw.ready = () => {
          for (let i = 0; i < paramInfo.length; i++) {
            app.use(paramInfo[i])
          }

          app.mount('#app')

          jw.getAuthCode({
            url: paramUrl,
          }, {
            success: function (res) {
              console.log('res-code', res)
              //获取用户信息
              ds.getUserInfo(dataInfo, res.code, urlData).then((result) => {
                resolve(result)
              }).catch((err) => {
                reject(err)
              })
            },
            fail: function (err) {
              console.log('err', err)
              reject(err)
            }
          })
        }

        jw.error = (error) => {
          console.log('error', error)
        }

        jw.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert //出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出， //仅在 pc 端时才会打印。
          appid: dataInfo.appid, // 必填，公众号/应用号的唯一标识
          corpid: dataInfo.corpid, // 必填开发者 ID(系统管理->应用管理->企业开发者)
          signature: dataInfo.signature, // 必填，签名(第三方应用用 sha1 算法生成的签名，这个签
          timestamp: dataInfo.timestamp, // 必填，时间戳(10 位)
          nonceStr: dataInfo.noncestr, // 必填，生成签名的随机串
        })

      } else {
        reject(resultData)
      }
    }).catch((err) => {
      console.log('err', err)
      reject(err)
    })
  })

}

// 获取用户信息
ds.getUserInfo = (params, code, urlData) => {
  let signature = util.SHA1("encrypt_txt=" + params.corpsecret + "&token=" + params.corpid +
    "&nonce=" + params.noncestr + "&timestamp=" + params.timestamp + "")
  let brandCode = ''
  if (urlData['brand_code']) {
    brandCode = urlData['brand_code']
  }
  let headData = {
    'Content-Type': 'application/json',
    'Access-token': '',
    'Device-id': '',
    'Client-id': '',
    'Token-type': 'bearer',
    'Version': '',
    'brand': '',
    'signature': signature,
    'timestamp': params.timestamp,
    'nonce': params.noncestr
  }
  return new Promise((resolve, reject) => {
    axios({
      headers: headData,
      method: 'POST',
      url: `${DS_API_BASE_URL}/joywok/get_joywok_user`,
      data: { 'code': code, 'brand_code': brandCode }
    }).then(result => {
      let resultData = result.data
      console.log('resultData', resultData)
      if (resultData.code == 0) {
        resolve(resultData.data)
      } else {
        reject(resultData)
      }
    }).catch((err) => {
      reject(err)
    })
  })

}

export { ds }